import React, { useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';

import { useSystemAlertContext } from 'src/contexts/SystemAlertContext';
import NotificationBanner from 'src/components/NotificationBanner';
import selectTopAlert from 'src/components/SystemAlertBanner/utils';

const BANNER_HEIGHT = 50;

const SystemAlertBanner = () => {
  const { systemAlertState } = useSystemAlertContext();
  const [dismissedAlertIds, setDismissedAlertIds] = useState(new Set());
  const previousHasBannerRef = useRef(null);
  const previousAlertGenerationRef = useRef(systemAlertState?.alertGeneration);

  // Reset dismissed alerts when alert generation changes (alerts were cleared/reset)
  useEffect(() => {
    const currentGeneration = systemAlertState?.alertGeneration || 0;
    const previousGeneration = previousAlertGenerationRef.current || 0;

    if (currentGeneration !== previousGeneration) {
      setDismissedAlertIds(new Set());
      previousHasBannerRef.current = null;
    }

    previousAlertGenerationRef.current = currentGeneration;
  }, [systemAlertState?.alertGeneration]);

  const visibleAlerts = (systemAlertState?.alerts || []).filter(
    (alert) => !dismissedAlertIds.has(alert.id)
  );
  const top = selectTopAlert(visibleAlerts);

  useEffect(() => {
    if (!!top !== previousHasBannerRef.current) {
      if (top) {
        document.body.style.paddingTop = `${BANNER_HEIGHT}px`;
        document.documentElement.style.setProperty('--global-banner-height', `${BANNER_HEIGHT}px`);
      } else {
        document.body.style.paddingTop = '0px';
        document.documentElement.style.removeProperty('--global-banner-height');
      }

      previousHasBannerRef.current =  !!top;
    }
  }, [top]);

  useEffect(() => {
    return () => {
      document.body.style.paddingTop = '0px';
      document.documentElement.style.removeProperty('--global-banner-height');
    };
  }, []);

  const handleClose = () => {
    if (top?.id) {
      setDismissedAlertIds((prev) => new Set([...prev, top.id]));
    }
  };

  if (!top) return null;

  return ReactDOM.createPortal(
    <NotificationBanner
      severity={top.severity}
      message={top.message}
      actionLabel={top.actionLabel}
      onAction={top.onAction}
      onClose={handleClose}
      title={top.title}
      height={BANNER_HEIGHT}
    />,
    document.getElementById('global-alert-banner')
  );
};

export default SystemAlertBanner;
